module.exports = __webpack_public_path__ + "img/turfy2_mem.af71ef4c.png";